import Vue from 'vue/dist/vue.esm';
import { initSentry } from '../shared/sentry_config';

// Initialize Sentry
initSentry(Vue);

import axios from 'axios';
import swal from 'sweetalert2';

document.addEventListener('DOMContentLoaded', () => {
  const baseUrl = document.querySelector('meta[name=ax-base-url]').content;
  const authToken = document.querySelector('meta[name=ax-auth-token]').content;

  axios.defaults.baseURL = baseUrl;
  axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
  axios.defaults.headers.common.Accept = 'application/json';

  // Because the auth codebase is so tiny, and intertwined with .html.erb so heavily,
  // we sprinkle the logic into this vue app, rather than standalone components
  const app = new Vue({
    el: '#auth-form',
    data: {
      users: null,
      signUpUrl: null,
      actionName: null,
    },
    mounted() {
      this.signUpUrl = this.$el.attributes['sign-up-url'].value;
      this.actionName = this.$el.attributes['action-name'].value;
    },
    computed: {
      // The API gives us a couple users to choose from, we default to full users if possible
      userToSignIn() {
        if (!this.users) {
          return null;
        }

        return _.head(_.orderBy(this.users, ['account_type', 'id'], ['asc', 'desc']));
      },
    },
    methods: {
      validateEmail(email) {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
      },
      checkForEmail() {
        const vm = this;
        const forGuests = document.querySelector('#user_is_guest').value === 'true';
        // Look up potential existing users
        const email = document.querySelector('#user_email').value;
        if (this.validateEmail(email)) {
          const url = `/api/team/v1/users?email=${encodeURIComponent(email)}&for_guests=${forGuests}`;
          axios.get(url)
            .then((response) => {
              // We have an account we can log this user into to prefill info
              if (response.data.users?.length > 0) {
                vm.users = response.data.users;
                vm.fireSwal();
              }
            })
            .catch((error) => {
              // We don't really need to catch errors here, we just dont' want it bubbling up
            });
        }
      },
      fireSwal() {
        const vm = this;
        const teamName = document.querySelector('meta[name=ax-team-name]').content;
        swal.fire({
          type: 'question',
          title: 'Welcome back!',
          text: `Would you like to sign in and pre-fill your registration with info you used last time with ${teamName}?`,
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonClass: 'btn btn-primary m-l-md',
          confirmButtonText: 'Yes, send me a sign in link',
          cancelButtonText: 'No, continue as guest',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            vm.sendLink();
          }
        });
      },
      sendLink() {
        swal.fire(
          'Check your inbox',
          'A magic sign in link is waiting for you. Click the link in the email to login.',
          'success',
        );
        axios.post('/api/team/v1/magic_links', {
          magic_link: {
            user_id: this.userToSignIn.id,
            after_sign_in_url: this.signUpUrl,
            action_name: this.actionName,
          },
        }).then((response) => {
          // qqq should that swal fire above be here instead?
        }).catch((error) => {
          // We don't really need to catch errors here, we just dont' want it bubbling up
        });
      },
    },
  });
});
